module.exports = __webpack_public_path__ + "static/media/note-currency.5537aa61.png";